import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import React from "react";

export function companySelectWidth(label, { max = 560, min = 180 } = {}) {
  const text = label || "Select Company";
  if (typeof document === "undefined") {
    return Math.min(Math.max(text.length * 8 + 64, min), max);
  }
  const canvas = companySelectWidth.canvas || (companySelectWidth.canvas = document.createElement("canvas"));
  const ctx = canvas.getContext("2d");
  ctx.font = "500 16px Poppins, Roboto, Helvetica, Arial, sans-serif";
  return Math.min(Math.max(Math.ceil(ctx.measureText(text).width) + 72, min), max);
}

export function longestCompanySelectWidth(labels, opts) {
  const names = (labels || []).filter(Boolean);
  if (names.length === 0) {
    return companySelectWidth("Select Company", opts);
  }
  return Math.max(...names.map((name) => companySelectWidth(name, opts)));
}

export const CompanySelect = ({
  companies: companyOptions = [],
  value,
  onChange,
  label = "Select Company",
  tone = "onLight",
  maxWidth = 560,
}) => {
  const companies = companyOptions.filter((company) => Number(company.dst) !== 0);
  const matched = companies.find((company) => String(company.companyID) === String(value));
  const selectValue = matched ? matched.companyID : "";
  const labelColor = tone === "onBlue" ? "#fff" : "#1a365d";
  const width = companySelectWidth(matched?.name || "Select Company", { max: maxWidth, min: 220 });

  return (
    <Box sx={{ width: { xs: "100%", sm: width }, maxWidth: "100%", flexShrink: 0 }}>
      <Typography variant="caption" sx={{ fontWeight: 700, color: labelColor, fontSize: "14px" }}>
        {label}
      </Typography>
      <FormControl size="small" fullWidth sx={{ mt: 0.5 }}>
        <Select
          value={selectValue}
          onChange={onChange}
          displayEmpty
          sx={{
            borderRadius: "6px",
            backgroundColor: "#f8fafc",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#cbd5e1",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#94a3b8",
            },
            "& .MuiSelect-select": {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
          }}
        >
          <MenuItem value="" disabled>
            Select Company
          </MenuItem>
          {companies.map((company) => (
            <MenuItem key={company.companyID} value={company.companyID}>
              {company.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
